import Locality from '../locality/Locality';
import prependProtocol from '../common/utils/prependProtocol';
import { ContentCallResult } from '../common/interfaces';

export interface GetContentDataArgs {
  body: Locality;
  contentHost: string;
  contentId: string;
  headers: Record<string, string>;
  tenantId: string;
  timeout: number;
}

/**
 * Get data necessary to initialize the sdk.
 * @param args - see: GetContentDataArgs
 *
 * @returns Promise promise that contains a \{data, request\} payload on success
 */

export default async function (
  args: GetContentDataArgs
): Promise<ContentCallResult> {
  const host = prependProtocol(args.contentHost);
  const { body, contentId, headers, tenantId } = args;
  const pathname = `/api/tenant/${tenantId}/content/${contentId}`;
  const url = new URL(pathname, host).toString();
  const options: RequestInit = {
    body: JSON.stringify(body),
    headers: {
      ...headers,
      'Content-Type': 'application/json; charset=utf-8'
    },
    method: 'POST',
    mode: 'cors' as RequestMode
  };
  if (args.timeout) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), args.timeout);
    options.signal = controller.signal;
  }
  const res = await fetch(url, options);
  if (res.ok) {
    return (await res.json()) as ContentCallResult;
  } else {
    return Promise.reject(res);
  }
}
